import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";

import { IInfluencer, Influencer } from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";

export function useUpdateInfluencer() {
  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<
    { influencer: Partial<IInfluencer>; influencerId: string },
    BackednResponse<IInfluencer> | void
  >({
    mutationFn: async ({ influencer, influencerId }) => {
      return await InfluencerService.updateInfluencer(
        influencer,
        influencerId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: INFLUENCER_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data, { influencerId }) => {
      c.invalidateQueries({ queryKey: INFLUENCER_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
      });
      c.invalidateQueries({
        queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
      });
    },
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
